enum asclepiusApiEvents {
    UNAUTHENTICATED_API_ERROR_RESPONSE_RECEIVED = "UNAUTHENTICATED_API_ERROR_RESPONSE_RECEIVED"
}

export default asclepiusApiEvents